import React, { useState } from "react"; // eslint-disable-line no-unused-vars
import { TextField } from "@mui/material";

export interface RequiredTextFieldProps {
  disabled: boolean;
  label: string;
  autoComplete?: string;
  helperText?: string;
  value: string;
  test: (value: string) => string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RequiredTextField = ({
  disabled,
  label,
  autoComplete,
  helperText,
  value,
  test,
  onChange,
}: RequiredTextFieldProps): React.JSX.Element | null => {
  const [hadFocus, setHadFocus] = useState<boolean>(false);
  let errorMessage = hadFocus ? test(value) : "";
  return (
    <TextField
      autoComplete={autoComplete}
      disabled={disabled}
      required={true}
      fullWidth={true}
      label={label}
      InputProps={{
        className: "tb_paper_input",
      }}
      helperText={
        errorMessage.length > 0 ? errorMessage : helperText ? helperText : " "
      }
      error={errorMessage.length > 0}
      value={value}
      onChange={onChange}
      onBlur={(
        event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
      ) => {
        setHadFocus(true);
      }}
    />
  );
};
